import React, { useState } from "react";
import { MapPinPlus } from "lucide-react";
import { Popover, PopoverContent, PopoverTrigger } from "./ui/popover";
import { Command, CommandEmpty, CommandGroup, CommandInput, CommandItem, CommandList } from "./ui/command";

// One-click "Assign to site" picker for rows that aren't linked to a project yet.
export default function AssignSiteButton({ projects, onAssign, testid }) {
  const [open, setOpen] = useState(false);
  const [busy, setBusy] = useState(false);
  const pick = async (pid) => {
    setBusy(true);
    try { await onAssign(pid); setOpen(false); } finally { setBusy(false); }
  };
  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <button className="btn-accent" disabled={busy} data-testid={testid} title="Link this to a site">
          <MapPinPlus size={13} /> {busy ? "Assigning…" : "Assign"}
        </button>
      </PopoverTrigger>
      <PopoverContent className="w-72 p-0" align="end">
        <Command>
          <CommandInput placeholder="Search sites…" data-testid={`${testid}-search`} />
          <CommandList>
            <CommandEmpty>No sites found.</CommandEmpty>
            <CommandGroup heading="Assign to site">
              {projects.map((p) => (
                <CommandItem key={p.id} value={`${p.name} ${p.postcode || ""} ${p.id}`} onSelect={() => pick(p.id)}
                  data-testid={`${testid}-option-${p.id}`}>
                  <span className="truncate">{p.name}</span>
                  {p.postcode && <span className="ml-auto font-mono text-[10px] muted">{p.postcode}</span>}
                </CommandItem>
              ))}
            </CommandGroup>
          </CommandList>
        </Command>
      </PopoverContent>
    </Popover>
  );
}
